// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_accordion_table__jnhnl {
  width: 100%;
  border-collapse: collapse;
}

.styles_accordion_table__jnhnl thead {
  background-color: #fafafa;
}

.styles_accordion_table__jnhnl th {
  padding: 10px 16px;
  text-align: left;
  font-weight: 600;
  color: #9e9e9e;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  box-sizing: border-box;
}

.styles_accordion_table__jnhnl thead tr {
  border-top: 1px solid #e0e0e0;
}

.styles_accordion_table__jnhnl th:hover {
  background-color: #f0f0f0;
}

.styles_accordion_table__jnhnl th,
.styles_accordion_table__jnhnl td {
  padding: 8px 16px;
  text-align: left;
  font-size: 0.875rem;
  color: #424242;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  height: 56px;
}

.styles_accordion_table__jnhnl td {
  border-bottom: 1px solid #f0f0f0;
}

.styles_accordion_table__jnhnl tbody tr:hover {
  background-color: #fafafa;
}

.styles_colunas__zLrc6 {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  gap: 5px;
  width: 100%;
}

.styles_button_action_container__dT\\+gO {
  display: flex;
  justify-content: flex-start;
}

.styles_stickyActionHeader__g3tp8,
.styles_stickyActionCell__KSVFM {
  position: sticky !important;
  right: 0;
  z-index: 2;
  box-shadow: -8px 0 12px rgba(255, 255, 255, 0.92);
}

.styles_stickyActionHeader__g3tp8 {
  background-color: #fafafa;
  z-index: 3;
}

.styles_stickyActionCell__KSVFM {
  background-color: #ffffff;
}

.styles_accordion_table__jnhnl tbody tr:hover .styles_stickyActionCell__KSVFM {
  background-color: #fafafa;
}

/* Colunas-chave fixas à esquerda (CNPJ + 2ª coluna identificadora, ex.: Competência) nas
 * tabelas largas (Contribuições/ECF/ICMS/ICMS-ST — ver Aba*.js) — espelha
 * .stickyActionHeader/.stickyActionCell (que já fixa a coluna Ações à direita), só que do
 * lado esquerdo: ao rolar horizontalmente, CNPJ e a coluna seguinte continuam visíveis em
 * vez de sumir da tela, e a sombra em .stickyKeyCol2 avisa que ainda há colunas pra rolar.
 * Largura FIXA nas duas colunas é proposital: position:sticky com múltiplas colunas exige
 * um "left" exato por coluna (a 2ª começa onde a 1ª termina) — não dá pra empilhar sem
 * isso. Não é usada por nenhuma tabela hoje enquanto a classe não for aplicada na JSX,
 * então não muda nada em tabela nenhuma fora das 4 que passarem a usá-la.
 */
.styles_stickyKeyHeader__xUbMS,
.styles_stickyKeyCell__T6uFr {
  position: sticky !important;
  z-index: 2;
}

.styles_stickyKeyHeader__xUbMS {
  background-color: #fafafa;
  z-index: 3;
}

.styles_stickyKeyCell__T6uFr {
  background-color: #ffffff;
}

.styles_accordion_table__jnhnl tbody tr:hover .styles_stickyKeyCell__T6uFr {
  background-color: #fafafa;
}

.styles_stickyKeyCol1__X33zH {
  left: 0;
  width: 190px;
  min-width: 190px;
  max-width: 190px;
}

.styles_stickyKeyCol2__42h-H {
  left: 190px;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);
}

.styles_button_action__XT1UT {
  align-items: center;
  background-color: #18316e;
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  display: flex;
  padding: 0.3rem 1.5rem;
}

.styles_accordion_details__oSYxg {
  /* background-color: #f1f1f1;   */
  box-shadow: 3px 3px 5px #f1f1f1;
  border-radius: 6px;
}

.styles_buttons__H6Tkn {
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.styles_unique_btn__U4zoq {
  align-items: center;
  background-color: #18316e;
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  justify-content: center;
  padding: 0.3rem 1.5rem;
  transition: background 0.3s;
}

.styles_unique_btn__U4zoq:hover {
  background-color: #163a61;
}

.styles_btn__tU5gF {
  align-items: center;
  background-color: #18316e;
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  padding: 0.3rem 1.5rem;
  width: 100%;
  transition: background 0.3s;
}

.styles_btn__tU5gF span {
  margin-right: 0.5rem;
}

.styles_btn__tU5gF:hover {
  background-color: #163a61;
}

.styles_aviso_vazio__ZF0c\\+ {
  color: #18316e;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCard/TableView/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,QAAQ;EACR,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;EASE;AACF;;EAEE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".accordion_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.accordion_table thead {\n  background-color: #fafafa;\n}\n\n.accordion_table th {\n  padding: 10px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #9e9e9e;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.accordion_table thead tr {\n  border-top: 1px solid #e0e0e0;\n}\n\n.accordion_table th:hover {\n  background-color: #f0f0f0;\n}\n\n.accordion_table th,\n.accordion_table td {\n  padding: 8px 16px;\n  text-align: left;\n  font-size: 0.875rem;\n  color: #424242;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  height: 56px;\n}\n\n.accordion_table td {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.accordion_table tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.colunas {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  gap: 5px;\n  width: 100%;\n}\n\n.button_action_container {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.stickyActionHeader,\n.stickyActionCell {\n  position: sticky !important;\n  right: 0;\n  z-index: 2;\n  box-shadow: -8px 0 12px rgba(255, 255, 255, 0.92);\n}\n\n.stickyActionHeader {\n  background-color: #fafafa;\n  z-index: 3;\n}\n\n.stickyActionCell {\n  background-color: #ffffff;\n}\n\n.accordion_table tbody tr:hover .stickyActionCell {\n  background-color: #fafafa;\n}\n\n/* Colunas-chave fixas à esquerda (CNPJ + 2ª coluna identificadora, ex.: Competência) nas\n * tabelas largas (Contribuições/ECF/ICMS/ICMS-ST — ver Aba*.js) — espelha\n * .stickyActionHeader/.stickyActionCell (que já fixa a coluna Ações à direita), só que do\n * lado esquerdo: ao rolar horizontalmente, CNPJ e a coluna seguinte continuam visíveis em\n * vez de sumir da tela, e a sombra em .stickyKeyCol2 avisa que ainda há colunas pra rolar.\n * Largura FIXA nas duas colunas é proposital: position:sticky com múltiplas colunas exige\n * um \"left\" exato por coluna (a 2ª começa onde a 1ª termina) — não dá pra empilhar sem\n * isso. Não é usada por nenhuma tabela hoje enquanto a classe não for aplicada na JSX,\n * então não muda nada em tabela nenhuma fora das 4 que passarem a usá-la.\n */\n.stickyKeyHeader,\n.stickyKeyCell {\n  position: sticky !important;\n  z-index: 2;\n}\n\n.stickyKeyHeader {\n  background-color: #fafafa;\n  z-index: 3;\n}\n\n.stickyKeyCell {\n  background-color: #ffffff;\n}\n\n.accordion_table tbody tr:hover .stickyKeyCell {\n  background-color: #fafafa;\n}\n\n.stickyKeyCol1 {\n  left: 0;\n  width: 190px;\n  min-width: 190px;\n  max-width: 190px;\n}\n\n.stickyKeyCol2 {\n  left: 190px;\n  width: 150px;\n  min-width: 150px;\n  max-width: 150px;\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);\n}\n\n.button_action {\n  align-items: center;\n  background-color: #18316e;\n  border: none;\n  border-radius: 10px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  padding: 0.3rem 1.5rem;\n}\n\n.accordion_details {\n  /* background-color: #f1f1f1;   */\n  box-shadow: 3px 3px 5px #f1f1f1;\n  border-radius: 6px;\n}\n\n.buttons {\n  display: flex;\n  justify-content: space-around;\n  gap: 10px;\n}\n\n.unique_btn {\n  align-items: center;\n  background-color: #18316e;\n  border: none;\n  border-radius: 10px;\n  color: white;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 14px;\n  font-weight: 500;\n  gap: 8px;\n  justify-content: center;\n  padding: 0.3rem 1.5rem;\n  transition: background 0.3s;\n}\n\n.unique_btn:hover {\n  background-color: #163a61;\n}\n\n.btn {\n  align-items: center;\n  background-color: #18316e;\n  border: none;\n  border-radius: 10px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  justify-content: center;\n  padding: 0.3rem 1.5rem;\n  width: 100%;\n  transition: background 0.3s;\n}\n\n.btn span {\n  margin-right: 0.5rem;\n}\n\n.btn:hover {\n  background-color: #163a61;\n}\n\n.aviso_vazio {\n  color: #18316e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion_table": `styles_accordion_table__jnhnl`,
	"colunas": `styles_colunas__zLrc6`,
	"button_action_container": `styles_button_action_container__dT+gO`,
	"stickyActionHeader": `styles_stickyActionHeader__g3tp8`,
	"stickyActionCell": `styles_stickyActionCell__KSVFM`,
	"stickyKeyHeader": `styles_stickyKeyHeader__xUbMS`,
	"stickyKeyCell": `styles_stickyKeyCell__T6uFr`,
	"stickyKeyCol1": `styles_stickyKeyCol1__X33zH`,
	"stickyKeyCol2": `styles_stickyKeyCol2__42h-H`,
	"button_action": `styles_button_action__XT1UT`,
	"accordion_details": `styles_accordion_details__oSYxg`,
	"buttons": `styles_buttons__H6Tkn`,
	"unique_btn": `styles_unique_btn__U4zoq`,
	"btn": `styles_btn__tU5gF`,
	"aviso_vazio": `styles_aviso_vazio__ZF0c+`
};
export default ___CSS_LOADER_EXPORT___;
